import api from '../../lib/api';
import { Notification, NotificationsResponse, UnreadCountResponse } from './types';

export const getNotifications = async (): Promise<Notification[]> => {
  const { data } = await api.get<NotificationsResponse>('notifications');
  return data.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const { data } = await api.get<UnreadCountResponse>('notifications/unread-count');
  return data.count;
};

export const markAsRead = async (id: string): Promise<Notification> => {
  const { data } = await api.put<Notification>(`notifications/${id}/read`);
  return data;
};
















